import { salesDepartment } from "@/grid/config/departments/sales";
import { sdrDepartment } from "@/grid/config/departments/sdr";
import type { DepartmentDefinition, DepartmentId } from "@/grid/core/types";

const departments: Record<DepartmentId, DepartmentDefinition> = {
  sales: salesDepartment,
  sdr: sdrDepartment,
};

export function getDepartment(id: string): DepartmentDefinition | undefined {
  if (id in departments) return departments[id as DepartmentId];
  return undefined;
}

export function listDepartments(): DepartmentDefinition[] {
  return Object.values(departments);
}

export function getDepartmentGridLabel(department: DepartmentDefinition): string {
  return department.gridLabel ?? `${department.name} Grid`;
}

export function isDepartmentId(id: string): id is DepartmentId {
  return id in departments;
}
